/* eslint-disable */

const baseHref = document.getElementsByTagName('base')[0].href;
console.log('before __webpack_public_path__/baseHref', __webpack_public_path__, baseHref);
if (baseHref !== '/table-editor/') {
  __webpack_public_path__ = baseHref + 'table-editor/';
}

/* eslint-enable */
